module.exports = __webpack_public_path__ + "img/Bike@2x.4607ab83.png";